export const parseCategory = (
  categoryId: string | undefined
): string[] | undefined => {
  if (!categoryId) return;

  const [category, subCategory, ...rest] = categoryId?.split('-');

  if (!subCategory) return [category];
  return [category, subCategory, rest.join('-')];
};
